/**
 * Stable CSS class names for E2E — Product comments / Comment filter drawer.
 */
export const CF = {
    root: 'product-comments-comment-filter',

    header: 'product-comments-comment-filter__header',
    headerTitleGroup: 'product-comments-comment-filter__header-title-group',
    headerIconWrap: 'product-comments-comment-filter__header-icon-wrap',
    headerTitle: 'product-comments-comment-filter__header-title',
    headerChip: 'product-comments-comment-filter__header-chip',
    closeButton: 'product-comments-comment-filter-input--button-close',

    panel: 'product-comments-comment-filter__panel',
    fieldsGrid: 'product-comments-comment-filter__fields-grid',

    fieldCommentId: 'product-comments-comment-filter-input--comment-id',
    fieldDateRangeWrap: 'product-comments-comment-filter-input--date-range-wrap',
    fieldStarRating: 'product-comments-comment-filter-input--star-rating',
    fieldStarResetChip: 'product-comments-comment-filter-input--chip-star-reset',

    fieldCustomerId: 'product-comments-comment-filter-input--customer-id',
    fieldStatusSelect: 'product-comments-comment-filter-input--status-select',
    fieldStatusMenuItem: 'product-comments-comment-filter-input--status-menu-item',

    fieldGrievanceGroup: 'product-comments-comment-filter-input--grievance-group',
    fieldGrievanceRadioAll: 'product-comments-comment-filter-input--grievance-all',
    fieldGrievanceRadioExists: 'product-comments-comment-filter-input--grievance-exists',
    fieldGrievanceRadioNone: 'product-comments-comment-filter-input--grievance-none',

    fieldSpecialCode: 'product-comments-comment-filter-input--special-code',
    fieldTagsWrap: 'product-comments-comment-filter-input--tags-wrap',

    fieldIsAgentGroup: 'product-comments-comment-filter-input--is-agent-group',

    fieldColorCode: 'product-comments-comment-filter-input--color-code',
    fieldOperatorSelect: 'product-comments-comment-filter-input--operator-select',
    fieldOperatorMenuItem: 'product-comments-comment-filter-input--operator-menu-item',

    fieldHasPhotoGroup: 'product-comments-comment-filter-input--has-photo-group',
    fieldHasPhotoRadioAll: 'product-comments-comment-filter-input--has-photo-all',
    fieldHasPhotoRadioExists: 'product-comments-comment-filter-input--has-photo-exists',
    fieldHasPhotoRadioNone: 'product-comments-comment-filter-input--has-photo-none',

    actionsRow: 'product-comments-comment-filter__actions-row',
    applyButton: 'product-comments-comment-filter-input--button-apply',
} as const;

export const cfCls = (...parts: Array<string | undefined |false>) => parts.filter(Boolean).join(' ');

